// WidgetHeader — En-tête interne d'un widget (icône + titre).
// À utiliser à l'intérieur d'un WidgetSection.
// Reproduit le style de l'en-tête de GenericCrudCard (taille sm).

// Import React
import React from 'react';

// Import FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

// --- Interface ---

interface WidgetHeaderProps {
	icon: IconDefinition;
	title: string;
	// Slot optionnel pour des actions à droite (boutons, badges, etc.)
	actions?: React.ReactNode;
}

// --- Composant ---

const WidgetHeader: React.FC<WidgetHeaderProps> = ({
	icon,
	title,
	actions,
}) => (
	<div className="flex items-center gap-2 mb-4 text-gray-800">
		<FontAwesomeIcon icon={icon} className="w-6 h-6" />
		<h2 className="text-2xl font-bold">{title}</h2>
		{actions && <div className="ml-auto">{actions}</div>}
	</div>
);

export default WidgetHeader;
